import * as React from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import TopbarMenuLink from '../../../../theme/pages/_layout/topbar/TopbarMenuLink';
import {DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown} from 'reactstrap';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import {connect} from 'react-redux';
import * as firebase from 'firebase/app';
import AppAction from '../../../../reduxstore/actions/action';
import {setIsAuthenticated} from '../../../../reduxstore/actions/action-creators';
import {ACCESS_TOKEN} from '../../../../utils/constants';

const Ava = process.env.PUBLIC_URL + '/img/ava.png';

interface TopbarProps {
    dispatch: (action: AppAction) => (any);
}

class TopbarProfile extends React.PureComponent<TopbarProps & RouteComponentProps<any>> {

    public handleLogout = () => {
        firebase.auth().signOut();
        localStorage.removeItem(ACCESS_TOKEN);
        this.props.dispatch(setIsAuthenticated(false));
        this.props.history.push('/login');
    };

    public render() {
        return (
            <UncontrolledDropdown className='topbar__profile'>
                <DropdownToggle className='topbar__avatar'>
                    <img className='topbar__avatar-img' src={Ava} alt='avatar'/>
                    <p className='topbar__avatar-name'>Nombre</p>
                    <DownIcon className='topbar__avatar-icon'/>
                </DropdownToggle>
                <DropdownMenu className='topbar__menu dropdown__menu'>
                    <DropdownItem onClick={this.handleLogout}>
                        <TopbarMenuLink title='Salir' icon='exit' onClick={this.handleLogout} path='/log_in'/>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }
}

export default withRouter(connect()(TopbarProfile));


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar-profile.tsx